<app-main-container>
  <div class="relative w-full">
    <!--Filtre-->
    <app-filter-bar *ngIf="isFilterVisible | async "></app-filter-bar>
    <!-- Button affichage Filtre -->
    <app-filter-bar-mobile-device></app-filter-bar-mobile-device>

    <!--Liste des produits-->
    <div class="w-full h-full
      md:p-5">
      <!--Titre-->
      <header class="py-6 flex w-full flex-column justify-content-center align-items-center p-3">

       <h2 class="p-2">Votre liste de produits</h2>
       <div class="flex w-full justify-content-center">
         <div *ngIf="productQuantity$ | async as productQuantity">
          <div [ngClass]="{
            'product--sold--visible': productFilterValue.areSoldProductVisible,
            'product--sold--not--visible': !productFilterValue.areSoldProductVisible}"
            class="flex justify-content-center align-items-center border-circle h-3rem w-3rem"
            *ngIf="productFilterValue$ | async as productFilterValue; else noProductFilter">
            <span> {{ productQuantity }}</span>
          </div>
          <!-- Données du filtrage non disponible-->
          <ng-template #noProductFilter>
            <div  class="flex justify-content-center align-items-center border-circle h-3rem w-3rem" *ngIf="productFilterValue$ | async as productFilterValue; else noProductFilter">
              <span> {{ productQuantity }}</span>
          </div>
          </ng-template>
         </div>
       </div>
      </header>

     <!--Liste des produits-->
      <main class="w-full flex flex-column align-items-center justify-content-center"
         *ngIf="sellerProducts$ | async as products" [@listAnimation]="products.length">
        <!-- Affichage liste de produits -->
        <div class="w-full flex flex-column
            lg:flex-row lg:flex-wrap lg:gap-5 lg:justify-content-center" *ngIf="products.length > 0; else emptyList">
          <li class="w-full lg:w-5" *ngFor="let product of products; let index = index; let isLast = last">
            <app-summarize-product class="w-full flex justify-content-center" [product]="product"></app-summarize-product>
          </li>
        </div>
        <!-- Si liste de produit vide -->
        <ng-template #emptyList>
          <app-products-list-empty></app-products-list-empty>
        </ng-template>
      </main>
    </div>
  </div>
</app-main-container>
